import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';

class DeleteAdornment extends React.Component {

  render() {

    const {classes, onClick, title, dataTest} = this.props;

    return (
        <InputAdornment position="end">
            <Tooltip title={title || 'Delete'} className={classes.smallIconButton}>
                <IconButton data-test={dataTest + "-delete"} onClick={onClick} size="small">
                    <DeleteIcon fontSize={this.props.fontSize} />
                </IconButton>
            </Tooltip>  
        </InputAdornment>
    );
  }
}

DeleteAdornment.propTypes = {
  dataTest: PropTypes.string,
  fontSize: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  classes: PropTypes.object
};

export default withStyles(styles)(DeleteAdornment);